import React from 'react';

import ApplicationOverlayContent from 'components/ApplicationLayout/ApplicationOverlayContent';

import { Container, Image, Close } from './styles';

interface Props {
  show: boolean;
  src?: string;
  onClose: () => void;
}

const ExpandedImage = ({ show, src, onClose }: Props) => (
  <ApplicationOverlayContent show={show} onClose={onClose}>
    <Container>
      <Close src="/corporate/images/close.svg" onClick={onClose} />
      <Image src={src} />
    </Container>
  </ApplicationOverlayContent>
);

export default ExpandedImage;
